<template>
  <div>
    <div class="place" :class="correct ? 'correct' : null">
      <h2>{{title}}</h2>
      <div class="faces">
        <i class="icon" v-for="(icon, i) in generatedIcons" :key="i">{{ icon }}</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Place',
  props: {
    title: String,
    number: Number,
    correct: Boolean,
  },
  data() {
    return {
      iconSprite: "🤪 😍 😁 🥺 🤩 🥸 😎 🥰 🤣 😤 🤯 🥶 🤭 😸 👀 👞 🐶 🐱 🐭 🐹 🐰 🦊 🐻 🐼 🐻‍ ❄️ 🐨 🐯 🦁 🐮 🐷 🐽 🐸 🐵 🐒 🐔 🐧 🦆 🐺 🐝 🐞 🐴 🐢 🐙 🦖 🐬 🐟 🦈 🐋 🐆 🦓 🦍 🦧"
    }
  },
  methods: {
    generateRandomNumber(max) {
      return Math.floor(Math.random() * max)
    },
  },
  computed: {
    icons() {
      return this.iconSprite.split(' ')
    },
    generatedIcons() {
      let icns = []
      let iconChosen = this.generateRandomNumber(this.icons.length)

      for (let i=0; i < this.number; i++) {
        icns.push(this.icons[iconChosen])
      }

      return icns
    }
  }
}
</script>

<style>
.place {
  border: 3px solid rgb(223, 54, 54);
  background: rgb(241, 210, 210);
  width: 130px;
}

.place h2 {
  color:black;
  margin: 0;
}

.correct {
  border: 3px solid green;
  background: rgb(176, 218, 156);
}

.faces {
  padding: 0px;
  min-height: 100px;
}

i {
  font-style: normal;
  font-size: 2rem;
}
</style>
